
import {defineComponent, PropType} from 'vue'
import ProductSelectorLine from "@/components/UI/product/ProductSelectorLine.vue";
import BasePlaceholderTable from "@/components/UI/Bootstrap/BasePlaceholderTable.vue";
import {
  PagedCatalogProductWithImageOverviewResultsRestDtoModel
} from "@/models/api/pharma-cpc-product-mgmt/PagedCatalogProductWithImageOverviewResultsRestDtoModel";
import {
  CatalogProductWithImageOverviewRestDtoModel
} from "@/models/api/pharma-cpc-product-mgmt/CatalogProductWithImageOverviewRestDtoModel";

export default defineComponent({
  name: "ProductSelectorList",
  components: {BasePlaceholderTable, ProductSelectorLine},
  emits: ['update:modelValue', 'selectSingleProduct', 'selectProducts'],
  data() {
    return {
      selectedProducts: [] as CatalogProductWithImageOverviewRestDtoModel[]
    }
  },
  props: {
    modelValue: {
      type: Array as PropType<CatalogProductWithImageOverviewRestDtoModel[]>,
      required: true
    },
    productsOverview: {
      type: Object as PropType<PagedCatalogProductWithImageOverviewResultsRestDtoModel>,
      required: true
    },
    singleProduct: {
      type: Boolean,
      required: true,
    },
    errors: {
      type: Object,
      required: true,
    },
    ready: {
      type: Boolean,
      required: true,
    }
  },
  mounted() {
    if (this.modelValue) {
      this.selectedProducts = [...this.modelValue];
    }
  },
  methods: {
    selectProducts() {
      this.$emit('selectProducts', this.selectedProducts);
    },
    selectProduct(product: CatalogProductWithImageOverviewRestDtoModel) {
      if (this.singleProduct) {
        this.$emit('selectSingleProduct', product);
      }
    },
    changeSelection(selection: {product: CatalogProductWithImageOverviewRestDtoModel, selected: boolean}) {
      if (selection.selected) {
        this.selectedProducts.push(selection.product);
      } else {
        const index = this.selectedProducts.indexOf(selection.product);
        this.selectedProducts.splice(index, 1);
      }
      this.$emit('update:modelValue', [...this.selectedProducts]);
    }
  }
});


